import { UAParser } from 'ua-parser-js'

const parser = new UAParser(window.navigator.userAgent)
const { type, vendor } = parser.getDevice()
console.log(parser.getDevice())

export const userAgent = parser.getResult()
console.log(userAgent)

export const isMobile = type === 'mobile' || type === 'tablet'

export const isiOS = () => {
  return (
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
      window.navigator.platform
    ) ||
    // iPad on iOS 13 detection
    (window.navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  )
}

export const OP = vendor
